// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { openSnackbar } from './notify';
import { displayBackdrop, hideBackdrop } from './loading';

const API_URL = process.env.REACT_APP_API_URL;

// Define a service using a base URL and expected endpoints
export const productService = createApi({
    reducerPath: 'productService',
    baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
    tagTypes: ['PRODUCT'],
    endpoints: (builder) => ({
        getProductList: builder.query({
            query: () => `product`,
            providesTags: [{ type: 'PRODUCT', id: 'all-product' }],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(displayBackdrop());
                try {
                    const { data } = await queryFulfilled;
                    if(data){
                        dispatch(hideBackdrop());
                    }
                } catch (err) {
                    const { error } = err;
                    dispatch(hideBackdrop());
                    dispatch(openSnackbar({ options: { variant: "error" }, message: error?.data?.message || 'Something went wrong, Please try again.' }));
                }
            },
            transformResponse: (response) => response.data,
        }),
        getProductObj: builder.query({
            query: (productKey) => `product/${productKey}`,
            providesTags: (result, error, arg) => [{ type: 'PRODUCT', id: arg }],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(displayBackdrop());
                try {
                    const { data } = await queryFulfilled;
                    if(data){
                        dispatch(hideBackdrop());
                    }
                } catch (err) {
                    const { error } = err;
                    dispatch(hideBackdrop());
                    dispatch(openSnackbar({ options: { variant: "error" }, message: error?.data?.message || 'Something went wrong, Please try again.' }));
                }
            },
            transformResponse: (response) => response.data,
        }),
        createProduct: builder.mutation({
            query: (initialPost) => ({ url: 'product', method: 'POST', body: initialPost }),
            invalidatesTags: [{ type: 'PRODUCT', id: 'all-product' }],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(displayBackdrop());
                try {
                    const { data } = await queryFulfilled;
                    if(data){
                        dispatch(hideBackdrop());
                    }
                } catch (err) {
                    const { error } = err;
                    dispatch(hideBackdrop());
                    dispatch(openSnackbar({ options: { variant: "error" }, message: error?.data?.message || 'Something went wrong, Please try again.' }));
                }
            },
        }),
        updateProduct: builder.mutation({
            query: ({productID, initialPost}) => ({ url: `product/${productID}`, method: 'PUT', body: initialPost }),
            invalidatesTags: (result, error, arg) => [{ type: 'PRODUCT', id: arg.productID }, { type: 'PRODUCT', id: 'all-product' }],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(displayBackdrop());
                try {
                    const { data } = await queryFulfilled;
                    if(data){
                        dispatch(hideBackdrop());
                    }
                } catch (err) {
                    const { error } = err;
                    dispatch(hideBackdrop());
                    dispatch(openSnackbar({ options: { variant: "error" }, message: error?.data?.message || 'Something went wrong, Please try again.' }));
                }
            },
        }),
        deleteProduct: builder.mutation({
            query: (initialPost) => ({ url: `product`, method: 'DELETE', body: initialPost }),
            invalidatesTags: (result, error, arg) => [{ type: 'PRODUCT', id: 'all-product' }],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(displayBackdrop());
                try {
                    const { data } = await queryFulfilled;
                    if(data){
                        dispatch(hideBackdrop());
                    }
                } catch (err) {
                    const { error } = err;
                    dispatch(hideBackdrop());
                    dispatch(openSnackbar({ options: { variant: "error" }, message: error?.data?.message || 'Something went wrong, Please try again.' }));
                }
            },
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProductListQuery, useGetProductObjQuery, useCreateProductMutation, useUpdateProductMutation, useDeleteProductMutation } = productService;